import React from "react";
import s from "./ButtonMAS.module.scss";
import TextMAS from "components/TextMAS/TextMAS";
import { CircularProgress } from "@mui/material";

/**
 *
 * @param {Object} props
 * @param {"md"|"medium"|"sm"|"small"|"table-bar-button"|"dialog-button"} props.size
 * @param {"primary"|"secondary"|"text"|"text-only"|"table-bordered-button"} props.variant
 *
 * @returns
 */

const ButtonMAS = ({
  label,
  startIcon,
  endIcon,
  isLoading,
  children,
  size,
  variant,
  disabled,
  onClick,
  smallWidth,
  nowrap,
  ...props
}) => {
  const sizeClass = [
    "md",
    "medium",
    "sm",
    "small",
    "table-bar-button",
    "dialog-button",
  ].includes(size && size.toLowerCase())
    ? `buttonMAS-size-${size}`
    : "buttonMAS-size-md";

  const styleClass = [
    "primary",
    "secondary",
    "text",
    "text-only",
    "bordered",
  ].includes(variant && variant.toLowerCase())
    ? `buttonMAS-variant-${variant}`
    : "buttonMAS-variant-primary";

  const classNames = [
    smallWidth && s["buttonMAS-small-width"],
    s["buttonMAS-base"],
    s[sizeClass],
    s[styleClass],
  ]
    .filter(Boolean)
    .join(" ");

  const getContent = () => {
    if (!startIcon && !endIcon && isLoading)
      return (
        <div className={s["buttonMAS-loading"]}>
          <CircularProgress />
        </div>
      );

    if (label || typeof children === "string")
      return (
        <div className={s["buttonMAS-text"]}>
          <TextMAS fontWeight="medium" nowrap={nowrap}>
            {label || children}
          </TextMAS>
        </div>
      );

    if (typeof children !== "string") return children;
  };

  return (
    <button
      className={classNames}
      onClick={onClick}
      disabled={disabled || isLoading}
      {...props}
    >
      {startIcon && isLoading ? (
        <div className={s["buttonMAS-loading"]}>
          <CircularProgress />
        </div>
      ) : (
        <div className={s["buttonMAS-icon"]}>{startIcon}</div>
      )}
      {getContent()}
      {endIcon && isLoading ? (
        <div className={s["buttonMAS-loading"]}>
          <CircularProgress />
        </div>
      ) : (
        <div className={s["buttonMAS-icon"]}>{endIcon}</div>
      )}
    </button>
  );
};

export default ButtonMAS;
